<template>
  <div id="app">
    <homepage />
    <!--    <HelloWorld msg="Welcome to Your Vue.js App" />-->
  </div>
</template>

<script>
import Homepage from "@/pages/homepage";

export default {
  name: "App",
  components: {
    Homepage
  },
  created() {
    document.title = 'Chunhakrai Homepage'
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #289af4;
  margin-top: 60px;
}
</style>
<style>
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css";
</style>
